"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var Bowser = __importStar(require("bowser/bundled"));
var UNSUPPORTED_BROWSER_MESSAGE = "\n\u304A\u4F7F\u3044\u306E\u30D6\u30E9\u30A6\u30B6\u306F\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u5BFE\u5FDC\u3057\u3066\u3044\u306A\u3044\u305F\u3081\u3001\u6B63\u3057\u304F\u52D5\u4F5C\u3057\u306A\u3044\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002<br>\n\u4EE5\u4E0B\u306E\u63A8\u5968\u30D6\u30E9\u30A6\u30B6\u3067\u306E\u3054\u5229\u7528\u3092\u304A\u9858\u3044\u3044\u305F\u3057\u307E\u3059\u3002\n<br><br>\u25CF\u30D1\u30BD\u30B3\u30F3\u306E\u30D6\u30E9\u30A6\u30B6\n<br>\u30FBWindows10\u3000/\u3000Edge\u3001Chrome\n<br>\u30FBmacOS (10.14\u4EE5\u964D\u63A8\u5968)\u3000/\u3000Safari\u3001Chrome\n<br>\u25CF\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u30FB\u30BF\u30D6\u30EC\u30C3\u30C8\u306E\u30D6\u30E9\u30A6\u30B6\n<br>\u30FBiOS(12\u4EE5\u964D)\u3000/\u3000Safari\n<br>\u30FBiPadOS(13\u4EE5\u964D) \u3000/\u3000Safari\n<br>\u30FBAndroid (6\u4EE5\u964D)\u3000/\u3000Chrome\n";
/*Bowser*/
var browser = Bowser.getParser(window.navigator.userAgent);
//console.log(browser.parse());
var isValidBrowser = browser.satisfies({
    windows: {
        "internet explorer": "<3",
        "microsoft edge": ">16",
        chrome: ">72"
    },
    macos: {
        safari: ">11",
        chrome: ">72"
    },
    iOS: {
        safari: '>11'
    },
    Android: {
        chrome: ">72"
    }
});
var osInfo = browser.parseOS();
var browserInfo = browser.getBrowser();
var isMobile = browser.parsePlatform().type === "mobile";
var isiPad = browserInfo.name === "Safari" && typeof document.ontouchstart !== 'undefined' && browser.parsePlatform().type !== 'mobile';
var isiOS = osInfo.name === 'iOS' || isiPad;
var isiPhone = isiOS && browser.getPlatform().type === 'mobile';
var isIE11 = browserInfo.name === "Internet Explorer" && browserInfo.version === "11.0";
var isAndroid = osInfo.name === 'Android';
var Notifier = /** @class */ (function () {
    function Notifier(message, template, callback) {
        var _this = this;
        this.template = template;
        this.alertbox = template.cloneNode(true);
        this.alertbox.addEventListener('touchmove', this.preventScroll, false);
        this.callback = callback;
        var messagebox = this.alertbox.querySelector('p');
        messagebox.innerHTML = message;
        this.lightbox = document.createElement('div');
        this.lightbox.setAttribute('class', 'lightbox');
        this.lightbox.setAttribute('style', "height:" + (document.body.scrollHeight + 'px'));
        this.lightbox.addEventListener('touchmove', this.preventScroll, false);
        this.button = this.alertbox.querySelector('.okButton');
        this.button.addEventListener('click', function (e) {
            var callback = _this.callback;
            _this.callback = undefined;
            _this.close();
            if (callback) {
                callback(true);
            }
        });
        var cancelButton = this.alertbox.querySelector('.cancelButton');
        if (cancelButton) {
            cancelButton.addEventListener('click', function (e) {
                var callback = _this.callback;
                _this.callback = undefined;
                _this.close();
                if (callback) {
                    callback(false);
                }
            });
        }
        document.body.insertBefore(this.lightbox, document.body.firstChild);
        document.body.appendChild(this.alertbox);
    }
    Notifier.show = function (message, callback) {
        var template = document.getElementById("template").querySelector(".notification.alert");
        return new Notifier(message, template, callback);
    };
    Notifier.unsupport = function (message, callback) {
        var template = document.getElementById("template").querySelector(".notification.unsupported");
        return new Notifier(message, template, callback);
    };
    Notifier.howto = function (message, callback) {
        var template = document.getElementById("template").querySelector(".notification.howto");
        return new Notifier(message, template, callback);
    };
    Notifier.confirm = function (message, callback) {
        var template = document.getElementById("template").querySelector(".notification.confirm.ending");
        return new Notifier(message, template, callback);
    };
    Notifier.confirm2 = function (message, callback) {
        var template = document.getElementById("template").querySelector(".notification.confirm.normal");
        return new Notifier(message, template, callback);
    };
    Notifier.confirmWithLabel = function (message, label, callback) {
        var view = document.getElementById("template").querySelector(".notification.confirm").cloneNode(true);
        view.querySelector(".okButton").textContent = label;
        return new Notifier(message, view, callback);
    };
    Notifier.prototype.preventScroll = function (e) {
        e.preventDefault();
    };
    Notifier.prototype.close = function () {
        this.alertbox.parentNode.removeChild(this.alertbox);
        this.lightbox.removeEventListener('touchmove', this.preventScroll, false);
        this.lightbox.parentNode.removeChild(this.lightbox);
        if (this.callback) {
            this.callback(false);
            this.callback = undefined;
        }
    };
    return Notifier;
}());
exports.Notifier = Notifier;
window.addEventListener("load", function () {
    if (isMobile) {
        document.body.classList.add("mobile");
    }
    if (!isValidBrowser) {
        Notifier.unsupport(UNSUPPORTED_BROWSER_MESSAGE, function (ok) {
        });
    }
});
